import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const ChannelListChannelAnimatableText = styled.div<React.CSSProperties>`
  display: flex;
  overflow: hidden;
  width: ${220 * Screen.widthRatio}px;
`;

export default withAnimation(ChannelListChannelAnimatableText);
